"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _actionify = _interopRequireDefault(require("@mulesoft/actionify"));
var sessionSelectors = _interopRequireWildcard(require("../domains/session/selectors"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // eslint-disable-next-line import/no-extraneous-dependencies
var actionifyWithContext = function actionifyWithContext(Service, serviceFn, identifier) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    once = _ref.once,
    requestCompare = _ref.requestCompare,
    successProps = _ref.successProps;
  return function (params) {
    return function (dispatch, getState, _ref2) {
      var config = _ref2.config;
      var serviceInstance = new Service(config);
      return (0, _actionify.default)(serviceFn(serviceInstance), identifier, {
        once: once,
        requestCompare: requestCompare,
        successProps: successProps
      })(function () {
        var state = getState();
        var context = sessionSelectors.context(state);
        return _objectSpread({
          context: context
        }, params);
      })(dispatch, getState);
    };
  };
};
var _default = exports.default = actionifyWithContext;
//# sourceMappingURL=actionify.js.map